import { EllipsisVertical } from "lucide-react";
import React from "react";

import { IgIconButton } from "@intelligems/ig-theme";
import { Menu } from "@mui/material";
import Grid from "@mui/material/Grid";

import { useExecutionPanelContext } from "../ExecutionPanelContext";
import { ExecutionPanelMenuItems } from "./ExecutionPanelMenuItems";

export const ExecutionPanelMenu = () => {
  const { getSlot, menuAnchorEl, openMenu, closeMenu } =
    useExecutionPanelContext();

  return (
    <Grid>
      <IgIconButton
        onClick={(e) => openMenu(e.currentTarget)}
        aria-label="More options"
      >
        <EllipsisVertical size={18} />
      </IgIconButton>
      <Menu
        anchorEl={menuAnchorEl}
        open={Boolean(menuAnchorEl)}
        onClose={closeMenu}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
      >
        {/* Overriding this slot replaces the built-ins, like every other slot;
            render `ExecutionPanelMenuItems` to keep them. */}
        {getSlot("menuItems", <ExecutionPanelMenuItems />)}
      </Menu>
    </Grid>
  );
};
